import { SESSION_STATUS } from "./session-status.js";
import { normalizePlannedIds } from "./session-rsvp.js";
import { updateSession } from "./sessions.js";

/**
 * Schnellbestätigung: alle geplanten Spieler als anwesend markieren.
 *
 * @param {object|null|undefined} session
 * @returns {Promise<{ ok: boolean, errorKey?: string }>}
 */
export async function confirmMobileSessionAttendance(session) {
  const sessionId = String(session?.id || "").trim();
  if (!sessionId)
    return { ok: false, errorKey: "mobile.trainingsdesk.session.notFound" };

  const presentIds = normalizePlannedIds(session);
  const result = await updateSession(sessionId, {
    present_ids: presentIds,
    attendance_confirmed: true,
    status: SESSION_STATUS.COMPLETED,
    cancelled_at: null,
    cancelled_reason: null,
    cancelled_note: null,
    cancelled_by: null,
  });

  if (!result?.ok) {
    return { ok: false, errorKey: "trainerstunden.planning.confirmFailed" };
  }
  return { ok: true };
}
